export default __webpack_public_path__ + "images/2de8f09986fca52b901f8444dc4dd14a-3_tablet_1067x470.webp";